export default __webpack_public_path__ + "static/media/expl_012_DE.97adb66d.png";